export default __webpack_public_path__ + "static/media/woman-pilgrim.2281933c.svg";